import { HIDDEN } from '../classnames/design-system';
import { FlavorSwitcher } from '../shared/flavor-switcher';
import ProductSelectDropdown from './product-select-dropdown';
import FlavorSelectDropdown from './flavor-select-dropdown';
import { SELECTORS } from './constants';

export default class ProductFlavorManager {
  constructor(container, onChange) {
    const productSwitcher = container.querySelector(`.${SELECTORS.PRODUCT_SWITCHER}`);
    const flavorSwitcher = container.querySelector(`.${SELECTORS.FLAVOR_SWITCHER}`);
    const flavorFilter = container.querySelector(`.${SELECTORS.FLAVOR_FILTER}`);

    if (productSwitcher) {
      this.productSwitcher = new ProductSelectDropdown(productSwitcher, this.handleChangeUI);
    }

    if (flavorSwitcher) {
      this.flavor = new FlavorSwitcher(flavorSwitcher, this.handleChangeUI);
    }

    if (flavorFilter) {
      this.flavorFilter = new FlavorSelectDropdown(flavorFilter, this.handleChangeUI);
    }

    this.onChange = onChange;
  }

  onChangeCard = (productId) => {
    const productCards = document.querySelectorAll(`.${SELECTORS.PRODUCT_CARD}`);

    [...productCards].forEach((card) => {
      if (card.dataset.productId === productId) {
        card.classList.remove(HIDDEN);
      } else {
        card.classList.add(HIDDEN);
      }
    });
  };

  onChangeBottle = (productId) => {
    const bottles = document.querySelectorAll(`.${SELECTORS.PRODUCT_BOTTLE}`);

    [...bottles].forEach((bottle) => {
      if (bottle.dataset.productId === productId) {
        bottle.classList.remove(HIDDEN);
      } else {
        bottle.classList.add(HIDDEN);
      }
    });
  };

  handleChangeUI = (productId) => {
    this.onChangeCard(productId);
    this.onChangeBottle(productId);
    this.onChange?.(productId);
  };

  initializeEventListeners = () => {
    this.productSwitcher?.init();
    this.flavorFilter?.init();
    this.flavor?.init();
  };
}
